import { ClassQueryService } from './classQueryService';
import { ClassMutationService } from './classMutationService';
import { EnrollmentService } from './enrollmentService';
import { ScheduleService } from './scheduleService';
import { StaffAssignmentService } from './staffAssignmentService';

// Type imports
import type { ClassCreateData, ClassUpdateData } from './classMutationService';

/**
 * Main ClassService that combines all class-related services
 * This maintains backward compatibility with existing code
 */
export const ClassService = {
  // Query methods
  getClasses: ClassQueryService.getClasses,
  getClassById: ClassQueryService.getClassById,
  getStudentsNotEnrolledInClass: ClassQueryService.getStudentsNotEnrolledInClass,
  
  // Mutation methods
  createClass: ClassMutationService.createClass,
  updateClass: ClassMutationService.updateClass,
  deleteClass: ClassMutationService.deleteClass,
  
  // Schedule methods
  getSchedulesForClass: ScheduleService.getSchedulesForClass,
  createSchedule: ScheduleService.createSchedule,
  updateSchedule: ScheduleService.updateSchedule,
  deleteSchedule: ScheduleService.deleteSchedule,
  
  // Enrollment methods
  getClassEnrollments: EnrollmentService.getClassEnrollments,
  enrollStudent: EnrollmentService.enrollStudent,
  unenrollStudent: EnrollmentService.unenrollStudent,
  removeEnrollment: EnrollmentService.removeEnrollment,
  createEnrollments: EnrollmentService.createEnrollments
};

// Export types and individual services
export type { ClassCreateData, ClassUpdateData };
export { ClassQueryService, ClassMutationService, EnrollmentService, ScheduleService, StaffAssignmentService };
